// extracted by mini-css-extract-plugin
export default {"container":"Styles_container__HxP+0","tagsContainer":"Styles_tagsContainer__OueCU","clearIcon":"Styles_clearIcon__nrV0f","popover":"Styles_popover__Wu04m"};